import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { Observable } from 'rxjs/internal/Observable';
import { ProcessoCartaCreditoFinanceiro } from '../shared/model/processo-carta-credito-financeiro.model';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProcessoCartaCreditoService {
  private readonly endpoint = '/sepin-backend/rest/processo-carta-credito';

  constructor(private readonly http: McticHttpClient) {
  }

  obterProcessoCartaCredito(): Observable<ProcessoCartaCreditoFinanceiro> {
    return this.http.get<ProcessoCartaCreditoFinanceiro>(this.endpoint);
  }

  obterProcessoRetificacaoCartaCredito(): Observable<ProcessoCartaCreditoFinanceiro> {
    return this.http.get<ProcessoCartaCreditoFinanceiro>(`${this.endpoint}/retificacao`);
  }

  salvar(isRetificacao: boolean) {
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    return this.http.post(this.endpoint, isRetificacao, {headers });
  }
}
